import * as React from 'react';
export const topupSvg = React.forwardRef(function topupSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.25 4.25H7a.75.75 0 0 0 0-1.5H4c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25V6.5a.75.75 0 0 0-1.5 0v4.25h-10v-6.5Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.5 7v1A.75.75 0 0 0 10 8V7a.75.75 0 0 0-1.5 0ZM7.25 7v1a2 2 0 1 0 4 0V7a2 2 0 1 0-4 0Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1 5.25a.75.75 0 0 1 .75.75v6.5c0 .414.336.75.75.75h10a.75.75 0 0 1 0 1.5h-10A2.25 2.25 0 0 1 .25 12.5V6A.75.75 0 0 1 1 5.25Zm11.5-5a.75.75 0 0 1 .75.75v1.25h1.25a.75.75 0 0 1 0 1.5h-1.25V5a.75.75 0 0 1-1.5 0V3.75H10.5a.75.75 0 0 1 0-1.5h1.25V1a.75.75 0 0 1 .75-.75Z',
    }),
  );
});
topupSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var topup = {
  category: 'icon',
  colorable: true,
  name: 'topup',
  svg: topupSvg,
};
